"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DelayedAction = void 0;
class DelayedAction {
    constructor(action, onComplete) {
        this.timeout = null;
        this.resolve = null;
        this.reject = null;
        this.action = action;
        this.onComplete = onComplete;
        const self = this;
        this._promise = new Promise((resolve, reject) => {
            self.resolve = resolve;
            self.reject = reject;
            self.delay();
        });
    }
    async execute() {
        let success = true;
        try {
            await this.action();
            if (this.resolve) {
                this.resolve(true);
            }
        }
        catch (e) {
            success = false;
            if (this.reject) {
                this.reject(e);
            }
            else {
                throw e;
            }
        }
        finally {
            this.resolve = null;
            this.reject = null;
            this.onComplete(success);
        }
    }
    promise() {
        return this._promise;
    }
    delay() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        const self = this;
        this.timeout = setTimeout(() => {
            self.timeout = null;
            self.execute().catch(e => console.error('failed to execute delayed action: ', e));
        }, 500);
    }
}
exports.DelayedAction = DelayedAction;
//# sourceMappingURL=delayed_action.js.map